module.exports = __webpack_public_path__ + "cc9a874098dc9ef8dae31d98b98bcd86.pdf";